import { graphql } from "gatsby";
import React, { useContext, useState } from "react";
import bg_video from "../assets/new-home-page/bg_graphic_flow.webm";
import graphicPoster from "../assets/new-home-page/bg_graphics_poster.webp";
import CustomButton from "../components/CustomButton";
import DemoModal from "../components/DemoModal";
import LogoMarquee from "../components/LogoMarquee";
import HeroSupportingAssetMonet from "../components/Slices/HeroSupportingAssetMonet";
import VideoComponent from "../components/VideoComponent";
import Layout from "../components/layout";
import CardFlex from "../components/newActive/CardFlex";
import HorizontalCard from "../components/newActive/HorizontalCard";
import AnnotateFooter from "../components/newAnnotate/AnnotateFooter";
import AnnotateG2Review from "../components/newAnnotate/AnnotateG2Review";
import AnnotateCaseStudyCard from "../components/newAnnotate/CaseStudyCard";
import CustomerStories from "../components/newAnnotate/CustomerStories";
import VerticalCard from "../components/newAnnotate/VerticalCard";
import SEO from "../components/seo";
import "../styles/page/new_annotation.scss";
import { pickSlice } from "../utilities/helpers";
import SingleEmailForm2 from "../components/Pieces/SingleEmailForm2";
import ModalContext, { ModalProvider } from "../Contexts/openModal";
// import { useMediaQuery } from "react-responsive";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import useWindowWidth from "../hooks/useBetterMediaQuery";

const ActivePage = ({ data, location }) => {
  const _data = data?.prismicAnnotateV3?.data || {};
  const page_section_2 =
    _data.body && _data.body.length > 3 ? _data.body[3] : undefined;
  const grid_section_2 =
    _data.body && _data.body.length > 4 ? _data.body[4] : undefined;
  const logosData = data.prismicTrustedBrandsLogos?.data;
  const [trusted_brands_list] = pickSlice(logosData, "trusted_brands_list");
  const [case_study_cards] = pickSlice(_data, "case_study_cards");
  const [contact_sales_quotes] = pickSlice(_data, "contact_sales_quotes");
  const [encord_other_products] = pickSlice(_data, "encord_other_products");
  const [customer_stories] = pickSlice(_data, "customer_stories");
  const [grid_section_1] = pickSlice(_data, "annotation_tools_grid_cards");
  const [page_section_1] = pickSlice(_data, "page_section_");
  // const isMobile = useMediaQuery({ maxWidth: 520 });
  const isMobile = useWindowWidth(520);
  const { isOpen, toggleModal, email, setEmail } = useContext(ModalContext);

  const VerticalCardIcons = [
    {
      icon: "https://encord.cdn.prismic.io/encord/684dae60-2526-4403-8005-847e6b65480b_annotate-icon.svg?fit=max",
    },
    {
      icon: "https://encord.cdn.prismic.io/encord/83549f38-37be-426c-a312-5107f575c736_testing.svg?fit=max",
    },
  ];
  return (
    <Layout mainClasses="" theme="newDefault">
      {isMobile && (
        <VideoComponent
          autoPlay
          poster={graphicPoster}
          className="absolute left-0 right-0 z-0 [mix-blend-mode:darken] lg:top-20 sm:top-16 hidden lg:block"
        >
          <source
            className="row-start-1 row-end-4"
            src={bg_video}
            type="video/webm"
          />
        </VideoComponent>
      )}

      <HeroSupportingAssetMonet />
      <article className="relative px-4 pt-12 mx-auto sm:px-5 max-w-7xl md:pt-24">
        <section>
          <section className="w-full max-w-4xl mx-auto text-center lg:max-w-full">
            <p className="text-xs font-medium uppercase sm:text-base text-green-1200 tracking-widest_1 ">
              {_data?.page_label?.text}
            </p>
            <div
              role="heading"
              aria-level="2"
              dangerouslySetInnerHTML={{ __html: _data?.heading?.html }}
              className={`text-gray-2700 strong_Active lg:px-10 tracking-[-1.5px] sm:tracking-[-2.4px] max-w-[288px] leading-9 sm:max-w-[648px] lg:max-w-[1008px] mx-auto font-manrope mt-3.5 text-2.5xl text-center sm:leading-tighter-13 lg:!min-w-[1008px] sm:text-4.5xl font-bold mb-5`}
            />

            <p className="sm:max-w-[648px] lg:max-w-[943px] mx-auto mb-5 text-sm text-center text-gray-600 sm:text-lg lg:text-xl md:mb-9 tracking-tight_1">
              {_data?.description?.text}
            </p>

            <section className="flex justify-center">
              <SingleEmailForm2
                openModal={toggleModal}
                setEmail={setEmail}
                buttonText={`Get started`}
              />
            </section>
          </section>
          {isMobile && (
            <section className="hidden pt-12 img_grayscale_opacity branding_loop_width lg:block">
              <p className="text-xs font-manrope font-semibold text-center uppercase tracking-widest_1 text-gray-600 -mb-0.5 lg:mb-1">
                {trusted_brands_list?.primary?.label?.text}
              </p>
              <LogoMarquee logoArray={trusted_brands_list} logoBackground="" />
            </section>
          )}

          <section className="hidden mt-10 bg-white border border-gray-1600 sm:py-5 rounded-2xl sm:rounded-2.5xl lg:py-12 sm:flex sm:px-5 lg:px-10 lg:mx-11">
            {_data?.hero_video?.url ? (
              <div>
                <VideoComponent
                  loop
                  autoPlay
                  muted
                  className="w-full h-auto lg-max-w-[1072px] mx-auto rounded-xl sm:rounded-2xl"
                >
                  <source src={_data?.hero_video?.url} type="video/mp4" />
                </VideoComponent>
              </div>
            ) : (
              <>
                {_data?.hero_image?.url ? (
                  // <GatsbyImage
                  //   image={getImage(_data?.hero_image)}
                  //   loading="eager"
                  //   fetchPriority="high"
                  //   width={_data?.hero_image?.dimensions?.width || 0}
                  //   height={_data?.hero_image?.dimensions?.height || 0}
                  //   alt="stats"
                  //   className="w-full h-auto max-w-4xl mx-auto md:mt-8"
                  // />
                  <img
                    src={_data?.hero_image?.url}
                    loading="eager"
                    width={_data?.hero_image?.dimensions?.width || 0}
                    height={_data?.hero_image?.dimensions?.height || 0}
                    alt="stats"
                    className="w-full h-auto max-w-4xl mx-auto md:mt-8"
                  />
                ) : (
                  <section className="w-full mt-20 bg-gray-200 2xl:mt-28 h-128" />
                )}
              </>
            )}
          </section>
        </section>
        <section className="pt-10 pb-5 mx-auto lg:mt-10 sm:py-10 lg:mx-11">
          <div className="flex flex-col justify-center items-center gap-2.5 pb-10">
            <h1 className="font-manrope text-2xl sm:text-3.25xl font-semibold leading-10 text-purple-1100 -tracking-[1.8px]">
              {customer_stories?.primary?.section_heading?.text}
            </h1>
            <p className="text-sm sm:text-lg tracking-tighter_3 text-gray-2500 max-w-[770px] text-center">
              {customer_stories?.primary?.section_description?.text}
            </p>
          </div>
          <CustomerStories data={customer_stories?.items} />
        </section>
        <section className="pb-10 lg:pb-10 lg:mx-11 ">
          <div className="bg-white rounded-2xl sm:rounded-2.5xl border border-gray-1600 ">
            <HorizontalCard data={page_section_1} openModal={toggleModal} />
            <CardFlex data={grid_section_1} />
          </div>
        </section>
        <section className="pb-10 lg:pb-10 lg:mx-11 ">
          <div className="bg-white rounded-2xl sm:rounded-2.5xl border border-gray-1600 ">
            <HorizontalCard
              data={page_section_2}
              openModal={toggleModal}
              isReverse={true}
            />
            <CardFlex data={grid_section_2} isReverse={true} />
          </div>
        </section>
        <section className=" flex justify-center p-4 sm:p-6 lg:p-10 my-5 sm:my-10 bg-gray-1600 rounded-2xl sm:rounded-2.5xl lg:mx-11">
          <section className="flex flex-col justify-center gap-6 sm:grid-flow-row sm:grid-cols-2 sm:grid ">
            {contact_sales_quotes?.items?.map((value, index) => (
              <AnnotateG2Review
                key={index}
                data={value}
                CardClass={`${
                  index === 0
                    ? "px-9 py-6 lg:p-11 gap-0 bg-white"
                    : "px-9 py-11 lg:p-11"
                }`}
                main_Head_class={`${
                  index === 0
                    ? "!pt-8 font-medium tracking-widest_1 uppercase leading-6 text-base"
                    : "pt-0"
                }`}
                heading_class={`${
                  index == 0
                    ? " mt-3.5 sm:leading-9 sm:leading-10 !text-2.5xl lg:text-[36px] !font-bold"
                    : "-tracking-[1.2px] text-"
                }`}
                sub_heading={value.sub_heading}
                sub_heading_class={`${
                  index == 0
                    ? "text-gray-1200 dark:!text-gray-1600 dark:opacity-60 mt-6 !min-h-[56px] tracking-tighter_3 text-lg lg:text-xl"
                    : "tracking-tighter_3 sm:text-base mt-6 text-gray-600 dark:text-gray-3000"
                }`}
                index={index}
                LogoDivClass={`${index == 0 ? "mt-5 " : "mt-6"}`}
              />
            ))}
          </section>
        </section>
        <section className=" py-5 sm:py-10 sm:rounded-2.5xl lg:mx-11">
          <AnnotateCaseStudyCard data={case_study_cards} />
        </section>
        <section className="flex justify-center pt-5 sm:justify-start lg:mx-11 sm:pt-10">
          <p className=" text-purple-1100 text-2xl sm:text-3.25xl font-manrope text-center sm:text-left font-semibold sm:tracking-[-1.8px] max-w-60 sm:max-w-full ">
            {encord_other_products?.primary?.section_heading?.text}
          </p>
        </section>
        <article className="py-5 sm:py-10 lg:mx-11">
          <section className="flex flex-col gap-6 overflow-x-auto HideScrollBar scroll-smooth sm:flex-row">
            {encord_other_products?.items.map((data, index) => (
              <VerticalCard
                icon={VerticalCardIcons[index].icon}
                data={data}
                key={index}
                descriptionClass={`min-h-[48px]`}
                outlineColor={`text-purple-1500`}
              />
            ))}
          </section>
        </article>
        <section className="lg:mx-11">
          <AnnotateFooter
            setEmail={setEmail}
            heading={_data?.cta_heading?.text}
            description={_data?.cta_description?.text}
            openModal={toggleModal}
            imageBG={true}
          />
        </section>
      </article>
      <DemoModal
        title={`Get started`}
        isOpen={isOpen}
        email={email}
        closeModal={toggleModal}
        location={location}
      />
    </Layout>
  );
};

const ActiveV3 = ({ data, location }) => {
  return (
    <ModalProvider>
      <ActivePage {...{ data, location }} />
    </ModalProvider>
  );
};

export default ActiveV3;

export const query = graphql`
  query {
    prismicAnnotateV3(uid: { eq: "active-v3" }) {
      data {
        cta_heading {
          text
          html
        }
        description {
          text
        }
        heading {
          html
          text
        }
        hero_image {
          alt
          url
          gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
        }
        hero_video {
          url
        }
        meta_description {
          text
        }
        meta_heading {
          text
        }
        page_label {
          text
        }
        body {
          ... on PrismicAnnotateV3DataBodyCustomerStories {
            id
            slice_type
            items {
              card_heading {
                html
                text
              }
              cta_link {
                url
              }
              cta_text {
                html
                text
              }
              icon {
                url
                alt
              }
            }
            primary {
              section_description {
                text
              }
              section_heading {
                text
                html
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyAnnotationTypes {
            id
            slice_type
            primary {
              section_description {
                text
              }
              section_heading {
                html
                text
              }
              section_label {
                text
              }
            }
            items {
              label {
                text
              }
              coming_soon
              label_icon {
                url
                alt
              }
              label_slide_image {
                url
                alt
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              label_slide_video {
                url
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyAnnotationToolsSection {
            id
            slice_type
            primary {
              section_label {
                text
              }
              section_heading {
                text
              }
              section_description {
                text
              }
              cta_text_2 {
                text
              }
              cta_text_1 {
                text
              }
              cta_link_2 {
                url
              }
              cta_link_1 {
                url
              }
            }
            items {
              slide_video {
                url
              }
              icon {
                url
                alt
              }
              slide_image {
                alt
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyAnnotationToolsCards {
            id
            slice_type
            items {
              card_video {
                url
              }
              card_image {
                alt
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              card_icon {
                alt
                url
              }
              card_heading {
                text
              }
              card_description {
                text
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyEncordProducts {
            id
            slice_type
            primary {
              section_label {
                text
              }
              section_heading {
                text
              }
              section_description {
                text
              }
            }
            items {
              product_video {
                url
              }
              product_sub_heading {
                text
              }
              product_image {
                url
                alt
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              product_icon {
                alt
                url
              }
              product_heading {
                text
              }
              product_description {
                text
              }
              cta_link {
                url
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyPageSection {
            id
            slice_type
            items {
              section_image {
                url
                alt
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              section_video {
                url
              }
            }
            primary {
              label {
                text
              }
              section_description {
                text
              }
              section_heading {
                text
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyCtaCard {
            id
            slice_type
            primary {
              cta_link {
                url
              }
              cta_text {
                text
              }
              reviewer_name {
                text
              }
              reviewer_role {
                text
              }
              section_description {
                text
              }
              section_heading {
                text
              }
              section_sub_heading {
                text
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyAnnotationToolsGridCards {
            id
            slice_type
            items {
              card_description {
                text
              }
              card_heading {
                text
              }
              card_image {
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              card_label {
                text
              }
              card_video {
                url
              }
              icon {
                url
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyContactSalesQuotes {
            id
            slice_type
            items {
              author_name {
                text
              }
              label {
                text
              }
              review_description {
                text
              }
              review_heading {
                text
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyCaseStudyCards {
            id
            slice_type
            items {
              link {
                url
              }
              icon {
                url
              }
              description1 {
                text
              }
              button_text {
                text
              }
            }
          }
          ... on PrismicAnnotateV3DataBodyEncordOtherProducts {
            id
            slice_type
            items {
              icon {
                url
              }
              cta_text {
                text
              }
              cta_link {
                url
              }
              card_label {
                text
              }
              card_image {
                url
                gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
              }
              card_heading {
                text
              }
              card_description {
                text
              }
            }
            primary {
              section_heading {
                text
              }
            }
          }
        }
        cta_description {
          text
        }
      }
    }
    prismicTrustedBrandsLogos(uid: { eq: "home-page-logos" }) {
      data {
        body {
          ... on PrismicTrustedBrandsLogosDataBodyTrustedBrandsList {
            id
            slice_type
            primary {
              label {
                html
                text
              }
            }
            items {
              brand_image {
                alt
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const Head = ({ data }) => {
  const _data = data?.prismicAnnotateV3?.data || {};
  return (
    <SEO
      title={_data?.meta_heading?.text}
      description={_data?.meta_description?.text}
    />
  );
};
